import StyledParser from "@components/common/StyledParser";
import withLazyLoad from "@hooks/withLazyLoad";
import dynamic from "next/dynamic";

interface IStrapiContent {
  overview: string;
  description: string;
}

const StyledParserDynamic = dynamic(
  () => import("@components/common/StyledParser"),
  { ssr: false }
);

const LazyComponent = ({
  description,
}: Pick<IStrapiContent, "description">) => {
  return <StyledParserDynamic value={description} />;
};

const LazyComponentWithLazyLoad = withLazyLoad(LazyComponent);

const StrapiContent = ({ overview, description }: IStrapiContent) => (
  <>
    {overview ? (
      <>
        <StyledParser value={overview} />
        {description && <LazyComponentWithLazyLoad description={description} />}
      </>
    ) : (
      <StyledParser value={description} />
    )}
  </>
);

export default StrapiContent;
